import CvSectionTemplate from './CvSectionTemplate';

export default function CvAssociations() {
  return (
    <CvSectionTemplate
      currentId="check_3"
      description="Dodaj informacje o przynależności do organizacji, stowarzyszeń lub klubów zawodowych."
    />
  );
}
